module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgc3Ryb2tlPSIjQkJCIiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjxwYXRoIGQ9Ik0xLjQzNiAyLjg5NWgxNy44MTJNMS40MzYgN2gxNy44MTIiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mycourses/SortOrder.svg
// module id = 249
// module chunks = 0